export default [
  {
    name: 'English - Vietnam Dictionary',
    description:
      'A ditionary was built in Object - Oriented Programming course at school',
    features: [
      '3000 words english common and its meaning in Vietnamese',
      'Pronouce vocalbulary with US voice',
      'Translate a paragraph and more with Google Translate',
      'Increase user experience with three themes'
    ],
    images: [
      {
        link: 'https://i.imgur.com/QEAQ5Cr.png',
        title: 'Add a new word'
      },
      {
        link: 'https://i.imgur.com/NcCihDf.png',
        title: 'Translate online'
      },
      {
        link: 'https://i.imgur.com/tJjgypy.png',
        title: 'Lovely theme'
      },
      {
        link: 'https://i.imgur.com/jj0q7oh.png',
        title: 'Dark theme'
      }
    ]
  },
  {
    name: 'Quizy',
    description: 'A quiz game for everyone that help people strengthen social knowledge',
    features: [
      'Eye-catching interface, easy to use',
      'Quiz with many topics such as science, society, history, literature, geography, ...',
      'Having rankings system so players can know their position'
    ],
    images: [
      {
        link: 'https://i.imgur.com/ghXOXON.png',
        title: 'Home page'
      },
      {
        link: 'https://i.imgur.com/m52aHCD.png',
        title: 'Game'
      },
      {
        link: 'https://i.imgur.com/wsXri9Y.png',
        title: 'Rank page'
      }
    ]
  },
  {
    name: 'hkm-cvit',
    link: '',
    description: 'My online CV',
    features: ['Using React.js']
  },
  {
    name: 'My Test',
    link: '',
    description: 'This is an online test system for everybody.',
    features: [
      'Using React.js for frontend (my responsibility)',
      'Using .NET Core for backend',
      'User can create question bank, categorize the question and make customized test or random test from bank',
      'User can do the test by input the accepted password',
      'Teacher can view of the test result and some data from statistics page'
    ],
    images: [
      {
        link: 'https://imgur.com/jaNE2sb.png',
        title: 'Bank page'
      },
      {
        link: 'https://imgur.com/gL42UP4.png',
        title: 'Create test page'
      },
      {
        link: 'https://imgur.com/9alqGrq.png',
        title: 'Review test page'
      },
      {
        link: 'https://imgur.com/6kQT7QC.png',
        title: 'Statistics page'
      }
    ]
  },
  {
    name: 'thaont-blog',
    link: 'https://thaont-blog.now.sh/',
    description: 'This is a blog site I wrote for my friend.',
    features: [
      'Using React.js',
      'Using Draft.js for edit blog',
      'Using Firebase database to store data'
    ],
    images: [
      {
        link: 'https://imgur.com/C5AZa1d.png',
        title: 'Home page'
      },
      {
        link: 'https://imgur.com/AWigbA2.png',
        title: 'Post Creator'
      },
      {
        link: 'https://i.imgur.com/h7l1yqs.png',
        title: 'Post page'
      },
      {
        link: 'https://imgur.com/wbxWDSR.png',
        title: 'Posts management page'
      }
    ]
  }
]
